<template>
  <v-card>
    <v-card-text>
      <div>#{{ item.id }}: {{ item.url }}</div>
      <pre style="white-space: pre-wrap">{{ item.options }}</pre>
      <hr>
      <template v-if="item.error">
        <div>{{ item.error.name }}: {{ item.error.message }}</div>
        <pre style="white-space: pre-wrap">{{ item.error.stack }}</pre>
      </template>
      <div v-else>No error</div>
      <hr>
      <template v-if="item.response">
        <div>Response: {{ item.response.status }} {{ item.response.statusText}}</div>
        <pre style="white-space: pre-wrap">{{ item.payload }}</pre>
      </template>
      <div v-else>No response</div>
    </v-card-text>
  </v-card>
</template>
<script>
  export default {
    props: {
      item: {
        type: Object,
        required: true
      }
    }
  };
</script>
